var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTabService = function SvgTabService(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "icon_1_",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cicle",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.969-.063C7.115-.063-.062 7.115-.062 15.968S7.115 32 15.969 32 32 24.822 32 15.969 24.822-.063 15.969-.063m0 29.669c-7.532 0-13.638-6.105-13.638-13.638S8.437 2.331 15.969 2.331c7.531 0 13.638 6.105 13.638 13.638S23.5 29.606 15.969 29.606",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "figure",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m24.797 12.567-4.673 3.909a3.144 3.144 0 0 1-4.035-4.823L20.7 7.796a7.65 7.65 0 0 0-8.16 1.054c-2.502 2.093-3.321 5.443-2.321 8.355a3 3 0 0 0-.633.557l-2.537 2.311a3.145 3.145 0 0 0 4.811 4.048l2.537-2.31c.016-.019.025-.041.041-.06a7.65 7.65 0 0 0 7.927-1.16 7.66 7.66 0 0 0 2.432-8.024",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTabService);
export default ForwardRef;